import { fromJS } from 'immutable';

export function request(state) {
    return state.set('deleteMarketsFromTag', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { data }) {
    return state.set('deleteMarketsFromTag', fromJS({
        status: 'FINISHED',
        data
    }));
}

export function error(state) {
    return state.set('deleteMarketsFromTag', fromJS({
        status: 'ERROR'
    }));
}
